import type { StatusTone } from '@/components/shell/StatusChip';
import type { ApplicationStatus } from '@/api/models';

/** Maps an application's status to one of the theme's five badge tones (foundations.md §7.8). */
export function applicationStatusTone(status: ApplicationStatus): StatusTone {
  return status === 'active' ? 'success' : 'warning';
}
